var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ServiceAndDocuments.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0dc26989\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ServiceAndDocuments.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Contents/Main/Customers/ServiceAndDocuments.vue
// module id = 641
// module chunks = 1